import {
    addPartsRequest,
    deletePartsRequest,
    editPartsRequest,
    getPartsListRequest,
    getPartsRequest,
    updatePartsRequest,
} from '../../../../services/network/region_services/parts';

class CommonPartsService {
    async addParts(values) {
        return await addPartsRequest(values);
    }

    async getParts(id) {
        return await getPartsRequest(id);
    }

    async getPartsList(payload) {
        return await getPartsListRequest(payload);
    }

    async deleteParts(id) {
        return await deletePartsRequest(id);
    }

    async editParts(updates) {
        return await editPartsRequest(updates);
    }

    async updateParts(updates) {
        return await updatePartsRequest(updates);
    }
}

export const PartsService = new CommonPartsService();
